export default __webpack_public_path__ + "static/media/ic_papua_new_guinea.e9e6c0d3.svg";